import Image from 'next/image';
import { PH_PLACEMENT } from '../../utils/posthogEvents';
import Link from 'next/link';
import {
  ArrowRightWhite,
  GreenBgTick,
  GreenTick,
  RedCross,
} from '../../assets/icons';
import { LogoNew } from '../../assets/images';
import StartTreatmentButton from './StartTreatmentButton';

export default function ComparisonTable({ CTAtext }) {
  const tableContent = [
    {
      id: 1,
      title: `Visit Fee`,
      hr: (
        <span className='tw-font-medium tw-text-xs lg:tw-text-base'>$40</span>
      ),
      others: (
        <span className='tw-font-medium tw-text-xs lg:tw-text-base'>
          $60-$250
        </span>
      ),
    },
    {
      id: 2,
      title: `Patient Rating`,
      hr: (
        <div className='tw-flex tw-flex-col tw-gap-y-1 2xl:tw-gap-y-4'>
          <span className='tw-font-medium tw-text-xs lg:tw-text-base'>
            Excellent
          </span>
          <span
            className='tw-font-medium tw-text-xs lg:tw-text-sm'
            style={{ color: '#717171' }}
          >
            4.2 out of 5
          </span>
        </div>
      ),
      others: (
        <div className='tw-flex tw-flex-col tw-gap-y-1 2xl:tw-gap-y-4'>
          <span className='tw-font-medium tw-text-xs lg:tw-text-base'>
            Average
          </span>
          <span
            className='tw-font-medium tw-text-xs lg:tw-text-sm'
            style={{ color: '#717171' }}
          >
            3 out of 5
          </span>
        </div>
      ),
    },
    {
      id: 3,
      title: `Provider Response Time`,
      hr: (
        <span className='tw-font-medium tw-text-xs lg:tw-text-base'>10m*</span>
      ),
      others: (
        <span className='tw-font-medium tw-text-xs lg:tw-text-base'>
          Hours or longer
        </span>
      ),
    },
    {
      id: 4,
      title: `24/7 availability`,
      hr: <GreenTick />,
      others: '----',
    },
    {
      id: 5,
      title: `Refund Policy`,
      hr: <GreenTick />,
      others: '----',
    },
    // {
    //   id: 6,
    //   title: `RX Cost`,
    //   hr: (
    //     <span className='tw-font-medium tw-text-xs lg:tw-text-base'>
    //       Up to 80% off
    //     </span>
    //   ),
    //   others: (
    //     <span className='tw-font-medium tw-text-xs lg:tw-text-base tw-pb-3'>
    //       Varies
    //     </span>
    //   ),
    // },
    // { id: 5, title: `Refunds`, hr: <GreenBgTick />, others: <RedCross /> },
  ];

  return (
    <section className='tw-w-full tw-bg-white tw-pt-0 tw-pb-0 md:tw-py-24'>
      <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
        <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-[1.05fr_.75fr_1.2fr] tw-gap-10 lg:tw-gap-14'>
          {/* LEFT */}
          <div className='tw-flex tw-flex-col tw-justify-center lg:tw-pt-8'>
            <h2 className='tw-m-0 tw-leading-12 tw-text-[32px] xl:tw-text-[48px] tw-font-semibold tw-mb-4 lg:tw-mb-6'>
              <span className=' gradientText'>Don&apos;t settle</span> for{' '}
              <br className='tw-hidden lg:tw-block' />
              less
            </h2>

            <p className='tw-m-0 tw-max-w-[36rem] tw-text-[#6B7280] tw-text-base tw-mb-8 lg:tw-mb-6 '>
              Fast, affordable medical care without the wait, confusion, or
              surprise costs.
            </p>

            <div className='tw-w-full lg:tw-w-fit lg:tw-place-self-start'>
              <Link
                href='/services'
                className=' tw-inline-flex tw-items-center tw-gap-3 tw-rounded-full tw-bg-[#0B0B0B] tw-text-white tw-px-6 tw-py-3 tw-shadow-sm hover:tw-opacity-90 tw-transition'
              >
                <StartTreatmentButton
                  //styles='tw-w-fit'
                  CTAtext={CTAtext || 'Sign Up and Save $40'}
                  placement={PH_PLACEMENT.COMPARISON_TABLE}
                />
              </Link>
            </div>
          </div>

          {/* MIDDLE LABELS (desktop only like screenshot) */}
          <div className='tw-hidden lg:tw-block tw-pt-28'>
            <ul className='tw-space-y-12 tw-list-none tw-p-0 [&>*:nth-child(3)]:!tw-mt-[4.0rem] [&>*:nth-child(4)]:!tw-mt-[2.8rem]'>
              {tableContent.map((item) => (
                <li
                  key={item.id}
                  className='tw-text-[#111827] tw-text-xl tw-font-medium'
                >
                  {item.title}
                </li>
              ))}
            </ul>
          </div>

          {/* RIGHT: two columns */}
          <div className='tw-w-full'>
            <div className='tw-grid tw-grid-cols-2 tw-gap-6 md:tw-gap-8 tw-items-start'>
              {/* 24DOC card */}
              <div className='tw-rounded-2xl comparisontableBG tw-border tw-border-[#D7F0EA] tw-shadow-sm tw-px-[.1rem] lg:tw-px-6 tw-pt-0 tw-pb-8'>
                {/* COLUMN HEADER (fixed height) */}
                <div className='tw-h-[110px] tw-flex tw-items-center tw-justify-center'>
                  <Image
                    src={LogoNew}
                    width={150}
                    height={70}
                    alt='24DOC'
                    className='tw-object-contain'
                    priority
                  />
                </div>

                {/* ROWS */}
                <ul className='tw-space-y-12 tw-list-none tw-p-0 tw-m-0'>
                  {tableContent.map((item) => (
                    <li key={item.id} className='tw-text-center'>
                      {/* Mobile label */}
                      <div className='lg:tw-hidden tw-mb-2 tw-text-sm tw-font-medium tw-text-[#111827]'>
                        {item.title}
                      </div>

                      <div className='tw-flex tw-justify-center'>
                        <div className='tw-text-base  tw-text-[#111827]'>
                          {item.hr}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Others */}
              <div className='tw-pt-0'>
                {/* COLUMN HEADER (fixed height to match logo column) */}
                <div className='tw-h-[110px] tw-flex tw-items-center tw-justify-center'>
                  <div className='tw-text-center tw-font-semibold tw-text-xl lg:tw-text-2xl tw-text-[#111827]'>
                    Others
                  </div>
                </div>

                {/* ROWS */}
                <ul className='tw-space-y-12 tw-list-none tw-p-0 tw-m-0'>
                  {tableContent.map((item) => (
                    <li key={item.id} className='tw-text-center'>
                      {/* Mobile label */}
                      <div className='lg:tw-hidden tw-mb-2 tw-text-sm tw-font-medium tw-text-[#111827]'>
                        {item.title}
                      </div>

                      <div className='tw-flex  tw-justify-center'>
                        <div className='tw-text-base sm:tw-text-lg lg:tw-text-xl tw-text-[#111827]'>
                          {item.others}
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <p className='tw-text-center tw-text-base tw-text-[#5F5F5F] tw-mt-10 tw-font-medium'>
              Trusted by thousands of patients nationwide.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
